module.exports = __webpack_public_path__ + "static/c1-540343b7c146d2ca94d67f04b2969be6.jpg";